// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__C5hiF","inline-label":"Label_inline-label__2IRsO"};